/** 
*@author: satyamurthy.a
*@Description : 
**/
import { connect } from 'react-redux';
import React, { useState, useEffect, useRef } from 'react';
import ListView from '../../../Utils/ListView';
import Highlighter from 'react-highlight-words';
import { constant } from '../../../Utils/constants';
import translation from '../../../../../commons/translation';

import { Tag, Input, Popconfirm, Tooltip,Button } from 'antd';
import {
  getEmergencyWorkOrdersList,
  deleteWorkOrder,
  changeWorkOrderStatus,
  getUsersList
} from '../../../Utils/FormCalls';
import {
  SearchOutlined,
  DeleteOutlined,
  // EditOutlined,
  QuestionCircleOutlined
} from '@ant-design/icons';

const EquipmentOverviewList = (props) => {

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          danger
          
          style={{ width: 90 }}
          onClick={() => {
            clearFilters();
            confirm({ closeDropdown: true });
          }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{ color: filtered ? '#1890ff' : undefined, }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex] && record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const [columns, setColumns] = useState([
    {
      title: translation(props.translationCache, constant.workOrder),
      dataIndex: 'WorkOrder',
      key: 'WorkOrder',
      filter: true,
      ...getColumnSearchProps('WorkOrder')
    },
    {
      title: translation(props.translationCache, constant.description),
      dataIndex: 'Description',
      key: 'Description'
    },
    {
      title: translation(props.translationCache, constant.site),
      dataIndex: 'SiteId',
      key: 'SiteId',
      filter: true
    },
    {
      title: translation(props.translationCache, constant.status),
      dataIndex: 'Status',
      key: 'Status',
      render: (text, record) => (
        <Tooltip title={`Click To ${text === 'Active' ? 'Inactive' : 'Active'}`}>
          <span onClick={() => changeStatus(record.Id)}>
            <Tag
              color={
                text === 'Active'
                  ? '#87d068'
                  : text === 'Inactive'
                    ? '#ff4d4f'
                    : 'gold'
              }
              key={text}
            >
              {text}
            </Tag>
          </span>
        </Tooltip>
      )
    },
    {
      title: translation(props.translationCache, constant.action),
      width: '600',
      render: (text, record) => (
        <>

          <Popconfirm
            title={translation(
              props.translationCache,
              constant.areYouSureThatYouWantToDeleteTheEmergencyWorkOrder
            )}
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => deleteJobplan(record.Id)}
            okText="Yes"
            cancelText="No"
          >
            <Button>
              <DeleteOutlined />
            </Button>
          </Popconfirm>
        </>
      )
    }
  ]);

  const [dataSource, setDataSource] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [userList, setUserList] = useState([]);
  const searchInput = useRef(null);

  const config = {
    title: 'Equipment Overview',
    viewTypes: ['add', 'card', 'table'],
    defaultViewType: 'table',
    filterType: 'ByAttributeValue',
    attributeList: ['WorkOrder'],
    firstTitle: 'WorkOrder',
    secondTitle: 'CreatedBy',
    thirdTitle: 'CreatedTime',
    actions: ['edit', 'delete'],
    edit: {
      byAttribute: 'Id',
      redirectURL: '/rubus/AMM/EquipmentOverviewDetails'
    },
    deletee: {
      byAttribute: 'Id'
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const data = await getEmergencyWorkOrdersList();
      setDataSource(data);
      const users = await getUsersList();

      setUserList(users);
    };
    fetchData();
  }, []);


  useEffect(() => {
    if (props.translationCache) {
      setColumns((prevColumns) => {
        return prevColumns.map((col) => ({
          ...col,
          title: translation(props.translationCache, col.dataIndex)
        }));
      });
    }
  }, [props.translationCache]);



  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const deleteJobplan = async (id) => {
    await deleteWorkOrder(id);
    const data = await getEmergencyWorkOrdersList();
    setDataSource(data);
  };

  const changeStatus = async (id) => {
    await changeWorkOrderStatus(id);
    const data = await getEmergencyWorkOrdersList();
    setDataSource(data);
  };

  // const editWorkOrder = (record) => {
  //   // Implement edit functionality here
  // };

  return (
    <ListView
      {...props}
      columns={columns}
      dataSource={dataSource}
      userList={userList}
      config={config}
      delete={deleteJobplan}
    />
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
});

export default connect(mapStateToProps)(EquipmentOverviewList);